// Enter all your detials in this file
// Logo images
import logogradient from "./assets/logo.svg";
import logo from "./assets/logo2.svg";
// Profile Image
import profile from "./assets/profile.jpg";
// Tech stack images
import html from "./assets/techstack/html.png";
import css from "./assets/techstack/css.png";
import sass from "./assets/techstack/sass.png";
import js from "./assets/techstack/js.png";
import react from "./assets/techstack/react.png";
import redux from "./assets/techstack/redux.png";
import tailwind from "./assets/techstack/tailwind.png";
import bootstrap from "./assets/techstack/bootstrap.png";
import vscode from "./assets/techstack/vscode.png";
import github from "./assets/techstack/github.png";
import git from "./assets/techstack/git.png";
import npm from "./assets/techstack/npm.png";
import postman from "./assets/techstack/postman.png";
import figma from "./assets/techstack/figma.png";
// Porject Images
import projectImage1 from "./assets/projects/project1.jpg";
import projectImage2 from "./assets/projects/project2.jpg";
import projectImage3 from "./assets/projects/project3.jpg";
import projectImage4 from "./assets/projects/project4.jpg";
import projectImage5 from "./assets/projects/project5.jpg";
import projectImage6 from "./assets/projects/project6.jpg";

// Logos
export const logos = {
  logogradient: logogradient,
  logo: logo,
};

// Enter your Personal Details here
export const personalDetails = {
  name: "ABDOU MOUSSA",
  tagline: "Frontend Web Developer",
  img: profile,
  about: `React.js Developer with One year of experience in building and enhancing user-friendly web applications. Skilled in
creating responsive interfaces, optimizing performance, and troubleshooting UI issues. Adept at working with modern
frontend frameworks and libraries, implementing clean and scalable code, and delivering seamless user experiences that
align with business goals. `,
};

// Enter your Social Media URLs here
export const socialMediaUrl = {
  linkdein: "https://www.linkedin.com/in/abdo-mousa-20a47b304/",
  github: "https://github.com/AbdoMousa22",
  twitter: "https://twitter.com/",
  instagram: "https://www.instagram.com/",
};

// Enter your Work Experience here
export const workDetails = [
  {
    Position: "Frontend Web Developer",
    Company: `Romooz`,
    Location: "Al Mansurah, Egypt",
    Type: "Full Time",
    Duration: "Sep 2021 - Dec 2021",
  },
  {
    Position: "Internship",
    Company: `Romooz`,
    Location: "Al Mansurah, Egypt",
    Type: "Internship",
    Duration: "Sep 2021 - Dec 2021",
  },
  {
    Position: "Internship",
    Company: ` Bravo Academy`,
    Location: "Zagazig, Egypt",
    Type: "Internship",
    Duration: "Nov 2022 - Mar 2023 ",
  },
];

// Enter your Education Details here
export const eduDetails = [
  {
    Position: "Frontend Development",
    Company: "Udemy, YouTube, Google, Medium",
    Location: "Online",
    Type: "Full Time",
    Duration: "Jan 2022 - Present",
  },
  {
    Position: "Bachelor of Computer Science",
    Company: `Zagazig University`,
    Location: "Zagazig, Egypt",
    Type: "Full Time",
    Duration: "Sep 2020 - Jun 2024 ",
  },
];

// Tech Stack and Tools
export const techStackDetails = {
  html: html,
  css: css,
  js: js,
  react: react,
  redux: redux,
  sass: sass,
  tailwind: tailwind,
  bootstrap: bootstrap,
  vscode: vscode,
  postman: postman,
  npm: npm,
  git: git,
  github: github,
  figma: figma,
};

// Enter your Project Details here
export const projectDetails = [
  {
    title: "To Do List App",
    image: projectImage1,
    description: `Developed a dynamic Task Management application using React JS, focused on delivering a seamless user experience through
                   efficient state management.`,
    techstack:
      "HTML|CSS|JavaScript|React Hooks|useState|useEffect|Context API ",
    previewLink: "https://abdomousa22.github.io/To-Do-List/",
    githubLink: "https://github.com/AbdoMousa22/To-Do-List",
  },
  {
    title: "Weather App",
    image: projectImage2,
    description: `Developed a real-time Weather Forecasting application using React JS, integrating third-party RESTful APIs (e.g.,
                  OpenWeatherMap) to deliver accurate meteorological data`,
    techstack: "HTML|CSS|JavaScript|React Hooks|useState|useEffect|Axios",
    previewLink: "https://abdomousa22.github.io/Weather-App/",
    githubLink: "https://github.com/AbdoMousa22/Weather-App",
  },
  {
    title: "Ecommerce App",
    image: projectImage3,
    description: `This is sample project description random things are here in description This is sample
                  project lorem ipsum generator for dummy content`,
    techstack:
      "HTML|CSS|JavaScript|React Hooks|useState|useEffect| Redux Toolkit",
    previewLink: "https://abdomousa22.github.io/Ecommerce-App/",
    githubLink: "https://github.com/AbdoMousa22/Ecommerce-App",
  },
];

// Enter your Contact Details here
export const contactDetails = {
  email: "mousaabdo335@gmail.com",
  phone: "01208611915",
};
